export const htmlToText = (value?: string | null): string | undefined => {
  if (!value) return undefined;

  const container = document.createElement('div');
  container.innerHTML = value.trim();
  return container.textContent?.trim() || undefined;
};

export default htmlToText;